import {
    css, Theme,
} from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        root: css`
            ${common.fullContainer};
            padding-bottom: 30px;
            display: flex;
            flex-direction: column;
        `,
        main: css`
            display: flex;
            flex-grow: 1;
            padding-top: 45px;
        `,
        content: css`
            height: 100%;
            ${common.flexJustityAlignCenter};
            justify-content: space-between;
            flex-direction: column;
            padding: 0 60px;
        `,
        page: css`
            ${custom.boxShadowRadius};
            ${custom.border};
            width: 100%;
        `,
        backdrop: css`
            color: #fff;
            z-index: ${theme.zIndex.drawer + 1};
        `,
    }
}

export default styles
